// ── Tab switching ──────────────────────────────────────────────────
document.querySelectorAll('.menus-tabs > li > button').forEach((btn) => {
  btn.addEventListener('click', () => {
    const btnId   = btn.getAttribute('id');
    const panelId = btn.getAttribute('aria-controls');

    document.querySelectorAll('.menus-tabs > li > button').forEach((b) => {
      b.setAttribute('aria-selected', b === btn);
    });

    document.querySelectorAll('.menus-panel').forEach((panel) => {
      panel.setAttribute('aria-hidden', panel.id !== panelId);
    });
  });
});

// ── Menu item accordion ───────────────────────────────────────────
document.querySelectorAll('.menu-item__toggle').forEach((btn) => {
  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const body     = document.getElementById(btn.getAttribute('aria-controls'));

    btn.setAttribute('aria-expanded', !expanded);
    if (body) body.setAttribute('aria-hidden', expanded);
  });
});
